import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import { AdvancedListRequest } from "types/api/commons";

import { RelatedProductBody, RelatedProductListItem } from "types/api/relatedProduct";

function useRelatedProductApi() {
    const { get, del, post, put } = useHttpManaged();
    const getAllRelatedProduct = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<RelatedProductListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<RelatedProductListItem>>({
            url: "/product-related",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    const createRelatedProduct = React.useCallback((body: RelatedProductBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, RelatedProductBody, ResponseWithId>({
            url: "/product-related",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateRelatedProduct = React.useCallback((pathParams: PathParamsWithId, body: RelatedProductBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, RelatedProductBody, null>({
            url: "/product-related/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteRelatedProduct = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/product-related/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    return {
        getAllRelatedProduct,
        createRelatedProduct,
        updateRelatedProduct,
        deleteRelatedProduct
    };
}

export default useRelatedProductApi;